export default async function resizeImage(imgFile: File, maxFileSize: number) {
  const maxDimension = 2048;
  const scaleStep = 0.7;
  const qualityStep = 0.2;

  const img = new Image();

  const imgLoaded = new Promise((resolve) => (img.onload = resolve));
  img.src = URL.createObjectURL(imgFile);
  await imgLoaded;

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Cannot get 2d canvas context");
  }

  // Encoding the full-size photo is slow, so start at a size that is plenty
  // for reading a receipt. Only shrink further if the result is still too big.
  let currentQuality = 0.8;
  let scale = Math.min(1, maxDimension / Math.max(img.width, img.height));

  while (currentQuality > 0.1) {
    console.log("Resizing image", scale, currentQuality);
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    const blob: Blob | null = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", currentQuality),
    );
    if (!blob) {
      throw new Error("Failed to create blob");
    }

    const blobSize = blob.size;

    if (blobSize <= maxFileSize) {
      return new File([blob], imgFile.name, { type: "image/jpeg" });
    }

    currentQuality -= qualityStep;
    scale *= scaleStep;
  }

  throw new Error("Error resizing image.");
}
